import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, ApiListResponse, ValuesInterface } from "interface/language";
import { StatusInterface } from "interface/common";

export const languageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLanguages: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_LANGUAGE,
        method: "GET",
        params,
      }),
      providesTags: ["Language"],
    }),
    getLanguageList: builder.query<ApiListResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: `${API.GET_LANGUAGE}/list`,
        method: "GET",
        params,
      }),
      providesTags: ["Language"],
    }),
    createLanguage: builder.mutation<ApiResponse, { params: ValuesInterface; onClose: () => void }>({
      query: ({ params }) => ({
        url: API.GET_LANGUAGE,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Language"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create language:", error);
        }
      },
    }),
    updateLanguage: builder.mutation<ApiResponse, { params: ValuesInterface; onClose: () => void }>({
      query: ({ params }) => ({
        url: API.GET_LANGUAGE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["Language"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update language:", error);
        }
      },
    }),
    updateLanguageStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_LANGUAGE}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Language"],
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Failed to update language status:", error);
        }
      },
    }),
    deleteLanguage: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_LANGUAGE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Language"],
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Failed to update language status:", error);
        }
      },
    }),
    bulkUpdateLanguageStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_LANGUAGE}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["Language"],
    }),
    bulkDeleteLanguages: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_LANGUAGE}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["Language"],
    }),
  }),
});

export const {
  useGetLanguagesQuery,
  useGetLanguageListQuery,
  useCreateLanguageMutation,
  useUpdateLanguageMutation,
  useUpdateLanguageStatusMutation,
  useDeleteLanguageMutation,
  useBulkUpdateLanguageStatusMutation,
  useBulkDeleteLanguagesMutation,
} = languageApi;

